import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {tap} from 'rxjs/operators';
import {Router} from '@angular/router';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private router: Router
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req)
     .pipe(tap(event => {
    }, err => {
      const url = this.router.url;
      // if (err.status === 404 || err.status === 500) {
      //   this.router.navigate(['/error']);
      // }
      if (err.status === 401 && url.indexOf('signin') === -1) {
        this.router.navigate(['/signin']);
      }
    }));
  }
}
